// DSL Generator - converts Machine IR to DSL text

export function generateDSL(machineIR) {
  if (!machineIR) return '';

  let dsl = `machine ${machineIR.name} {\n`;
  
  // Initial state
  dsl += `  initial state ${machineIR.initial}\n\n`;
  
  // Effects
  if (machineIR.effects && Object.keys(machineIR.effects).length > 0) {
    Object.entries(machineIR.effects).forEach(([name, effect]) => {
      dsl += `  effect ${name}`;
      if (effect.required_capabilities && effect.required_capabilities.length > 0) {
        const caps = effect.required_capabilities.map(c => c.name).join(', ');
        dsl += ` requires [${caps}]`;
      }
      dsl += '\n';
    });
    dsl += '\n';
  }
  
  // Guards
  if (machineIR.guards && Object.keys(machineIR.guards).length > 0) {
    Object.keys(machineIR.guards).forEach(name => {
      dsl += `  guard ${name}\n`;
    });
    dsl += '\n';
  }
  
  // Invariants
  if (machineIR.invariants && machineIR.invariants.length > 0) {
    machineIR.invariants.forEach(inv => {
      dsl += `  invariant ${inv.name}: "${inv.message}"\n`;
    });
    dsl += '\n';
  }
  
  // States
  if (machineIR.states) {
    Object.entries(machineIR.states).forEach(([stateId, state]) => {
      dsl += `  state ${stateId}`;
      if (state.type !== 'atomic') {
        dsl += ` [${state.type}]`;
      }
      dsl += ' {\n';
      
      // Entry effects
      if (state.entry && state.entry.length > 0) {
        state.entry.forEach(effect => {
          dsl += `    entry ${effect}\n`;
        });
      }
      
      // Exit effects
      if (state.exit && state.exit.length > 0) {
        state.exit.forEach(effect => {
          dsl += `    exit ${effect}\n`;
        });
      }
      
      // Transitions
      if (state.transitions && state.transitions.length > 0) {
        state.transitions.forEach(trans => {
          dsl += `    on ${trans.event}`;
          
          // Guards
          if (trans.guards && trans.guards.length > 0) {
            const guards = trans.guards.map(g => g.name).join(', ');
            dsl += ` [guard ${guards}]`;
          }
          
          dsl += ` -> ${trans.target}`;
          
          // Effects
          if (trans.effects && trans.effects.length > 0) {
            dsl += ' {';
            trans.effects.forEach((effect, idx) => {
              if (idx === 0) dsl += ' ';
              dsl += `effect ${effect}`;
              if (idx < trans.effects.length - 1) dsl += ', ';
            });
            dsl += ' }';
          } else {
            dsl += ' {}';
          }
          
          dsl += '\n';
        });
      }
      
      dsl += '  }\n\n';
    });
  }
  
  dsl += '}';
  
  return dsl;
}

// Calculate diff between two DSL strings
export function calculateDSLDiff(oldDSL, newDSL) {
  const oldLines = oldDSL.split('\n');
  const newLines = newDSL.split('\n');
  
  const changes = [];
  const maxLines = Math.max(oldLines.length, newLines.length);
  
  for (let i = 0; i < maxLines; i++) {
    const oldLine = oldLines[i] || '';
    const newLine = newLines[i] || '';
    
    if (oldLine !== newLine) {
      changes.push({
        line: i + 1,
        type: !oldLine ? 'added' : !newLine ? 'removed' : 'modified',
        old: oldLine,
        new: newLine
      });
    }
  }
  
  return changes;
}
